export default __webpack_public_path__ + "static/media/house-9.d4502c0f.jpg";